/* src/app/views/blog/blog.component.css */
::ng-deep p-paginator svg {
  transform: rotate(180deg);
}
/*# sourceMappingURL=blog.component.css.map */
